<template>
  <div>
    <div style='width:702.5pt;' ref="box">
      <table width="2223" border="0" cellpadding="0" cellspacing="0" style='width:1111.50pt;border-collapse:collapse;table-layout:fixed;' >
       <col width="117" span="2" class="xl67" style='mso-width-source:userset;mso-width-alt:2852;'/>
       <col width="117" span="4" class="xl68" style='mso-width-source:userset;mso-width-alt:2852;'/>
       <col width="117" span="2" class="xl69" style='mso-width-source:userset;mso-width-alt:2852;'/>
       <col width="99" span="248" class="xl69" style='mso-width-source:userset;mso-width-alt:2413;'/>
       <tr height="48" style='height:24.00pt;mso-height-source:userset;mso-height-alt:480;'>
        <td class="xl70" height="48" width="936" colspan="8" style='height:24.00pt;width:468.00pt;border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>用 户 信 息</td>
        <td class="xl69" width="99" style='width:49.50pt;'></td>
        <td class="xl69" width="99" style='width:49.50pt;'></td>
        <td class="xl69" width="99" style='width:49.50pt;'></td>
        <td class="xl159" width="99" style='width:49.50pt;'></td>
        <td class="xl160" width="99" style='width:49.50pt;'></td>
        <td class="xl160" width="99" style='width:49.50pt;'></td>
        <td class="xl160" width="99" style='width:49.50pt;'></td>
        <td class="xl160" width="99" style='width:49.50pt;'></td>
        <td class="xl160" width="99" style='width:49.50pt;'></td>
        <td class="xl160" width="99" style='width:49.50pt;'></td>
        <td class="xl160" width="99" style='width:49.50pt;'></td>
        <td class="xl160" width="99" style='width:49.50pt;'></td>
        <td class="xl160" width="99" style='width:49.50pt;'></td>
       </tr>
       <tr height="36" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl73" height="36" style='height:18.00pt;' x:str>姓名：</td>
        <td class="xl74"><input type="text" v-model="myForm.name"/></td>
        <td class="xl75" x:str>性别：</td>
        <td class="xl75"><input type="text" v-model="myForm.sex"/></td>
        <td class="xl75" x:str>年龄：</td>
        <td class="xl75"><input type="number" v-model="myForm.age"/></td>
        <td class="xl75" x:str>联系电话：</td>
        <td class="xl76"><input type="number" v-model="myForm.phone"/></td>
        <td class="xl161" colspan="3" style='mso-ignore:colspan;'></td>
        <td class="xl159"></td>
        <td class="xl160" colspan="9" style='mso-ignore:colspan;'></td>
       </tr>
       <tr height="36" class="xl66" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl77" height="36" colspan="8" style='height:18.00pt;border-right:1.0pt solid windowtext;border-bottom:1.0pt solid windowtext;' x:str>初<span style='mso-spacerun:yes;'>&nbsp;&nbsp; </span>步<span style='mso-spacerun:yes;'>&nbsp;&nbsp; </span>问<span style='mso-spacerun:yes;'>&nbsp;&nbsp; </span>询</td>
        <td class="xl162" colspan="3" style='mso-ignore:colspan;'></td>
        <td class="xl163" colspan="10" style='mso-ignore:colspan;'></td>
       </tr>
       <tr height="36" class="xl66" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl80" height="36" colspan="8" style='height:18.00pt;border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>检查眼睛的原因</td>
        <td class="xl162" colspan="3" style='mso-ignore:colspan;'></td>
        <td class="xl163" colspan="10" style='mso-ignore:colspan;'></td>
       </tr>
       <tr height="36" class="xl66" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl83" height="36" colspan="8" style='height:18.00pt;border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
          <el-checkbox-group v-model="myForm.jianchayuanyin">
            <el-checkbox label="定期检查"></el-checkbox>
            <el-checkbox label="眼睛不舒服"></el-checkbox>
            <el-checkbox label="视物不清"></el-checkbox>
            <el-checkbox label="配眼镜"></el-checkbox>
            <el-checkbox label="视力普查不合格"></el-checkbox>
            <el-checkbox label="其他"></el-checkbox>
          </el-checkbox-group>
        </td>
        <td class="xl66" colspan="3" style='mso-ignore:colspan;'></td>
        <td class="xl163" colspan="10" style='mso-ignore:colspan;'></td>
       </tr>
       <tr height="36" class="xl66" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl86" height="36" colspan="3" style='height:18.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>上次检查眼睛的日期：</td>
        <td class="xl84" colspan="5" style='border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;'>
          <input type="date" v-model="myForm.shangcijianchariqi"/>
        </td>
        <td class="xl66" colspan="3" style='mso-ignore:colspan;'></td>
        <td class="xl163" colspan="10" style='mso-ignore:colspan;'></td>
       </tr>
       <tr height="36" class="xl66" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl89" height="36" colspan="3" style='height:18.00pt;border-right:.5pt solid windowtext;border-bottom:none;' x:str>首次发现视力下降的年龄：</td>
        <td class="xl92" colspan="5" style='border-right:1.0pt solid windowtext;border-bottom:none;'>
          <input type="number" v-model="myForm.shoucixiajiangage"/>
        </td>
        <td class="xl66" colspan="3" style='mso-ignore:colspan;'></td>
        <td class="xl163" colspan="10" style='mso-ignore:colspan;'></td>
       </tr>
       <tr height="36" class="xl66" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl94" height="36" colspan="8" style='height:18.00pt;border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>戴镜史</td>
        <td class="xl66" colspan="3" style='mso-ignore:colspan;'></td>
        <td class="xl163" colspan="10" style='mso-ignore:colspan;'></td>
       </tr>
       <tr height="36" class="xl66" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl97" height="36" colspan="2" style='height:18.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>戴镜史</td>
        <td class="xl98" colspan="6" style='border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
          <el-radio v-model="myForm.daijingshi" label="从未戴镜">从未戴镜</el-radio>
          <el-radio v-model="myForm.daijingshi" label="经常戴">经常戴</el-radio>
          <el-radio v-model="myForm.daijingshi" label="需要时戴镜">需要时戴镜</el-radio>
        </td>
        <td class="xl66" colspan="3" style='mso-ignore:colspan;'></td>
        <td class="xl163" colspan="10" style='mso-ignore:colspan;'></td>
       </tr>
       <tr height="36" class="xl66" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl97" height="36" colspan="2" style='height:18.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>戴镜类型</td>
        <td class="xl100" colspan="6" style='border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
          <el-checkbox-group v-model="myForm.daijingleixing">
            <el-checkbox label="框架眼镜"></el-checkbox>
            <el-checkbox label="角膜塑形镜"></el-checkbox>
            <el-checkbox label="框架和隐形交替使用"></el-checkbox>
            <el-checkbox label="其他"></el-checkbox>
          </el-checkbox-group>
        </td>
        <td class="xl66" colspan="3" style='mso-ignore:colspan;'></td>
        <td class="xl163" colspan="10" style='mso-ignore:colspan;'></td>
       </tr>
       <tr height="36" class="xl66" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl97" height="36" colspan="2" style='height:18.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>每年度数改变</td>
        <td class="xl100" colspan="6" style='border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
          <el-radio v-model="myForm.meiniandushugaibian" label="小于100度">小于100度</el-radio>
          <el-radio v-model="myForm.meiniandushugaibian" label="大于100度（含）">大于100度（含）</el-radio>
        </td>
        <td class="xl66" colspan="3" style='mso-ignore:colspan;'></td>
        <td class="xl163" colspan="10" style='mso-ignore:colspan;'></td>
       </tr>
       <tr height="36" class="xl66" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl102" height="36" colspan="2" style='height:18.00pt;border-right:.5pt solid windowtext;border-bottom:1.0pt solid windowtext;' x:str>更换眼镜周期</td>
        <td class="xl104" colspan="6" style='border-right:1.0pt solid windowtext;border-bottom:1.0pt solid windowtext;' x:str>
          <el-radio v-model="myForm.genghuanyanjingzhouqi" label="每年">每年</el-radio>
          <el-radio v-model="myForm.genghuanyanjingzhouqi" label="每两年">每两年</el-radio>
          <el-radio v-model="myForm.genghuanyanjingzhouqi" label="两年以上">两年以上</el-radio>
        </td>
        <td class="xl66" colspan="3" style='mso-ignore:colspan;'></td>
        <td class="xl163" colspan="10" style='mso-ignore:colspan;'></td>
       </tr>
       <tr height="36" class="xl66" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl106" height="36" colspan="8" style='height:18.00pt;border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>用眼习惯</td>
        <td class="xl66" colspan="3" style='mso-ignore:colspan;'></td>
        <td class="xl163" colspan="10" style='mso-ignore:colspan;'></td>
       </tr>
       <tr height="36" class="xl66" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl109" height="36" colspan="3" style='height:18.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>日常视野需求</td>
        <td class="xl111" colspan="5" style='border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
          <el-checkbox-group v-model="myForm.richangshiyexuqiu">
            <el-checkbox label="无特殊"></el-checkbox>
            <el-checkbox label="远距大视野"></el-checkbox>
            <el-checkbox label="近距小视野"></el-checkbox>
          </el-checkbox-group>
        </td>
        <td class="xl66" colspan="3" style='mso-ignore:colspan;'></td>
        <td class="xl163" colspan="10" style='mso-ignore:colspan;'></td>
       </tr>
       <tr height="36" class="xl66" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl113" height="36" colspan="3" style='height:18.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>每天近距离用眼的时间（小时）：</td>
        <td class="xl115" colspan="5" style='border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;'>
          <input type="number" v-model="myForm.meitianjinjuli"/>
        </td>
        <td class="xl66" colspan="3" style='mso-ignore:colspan;'></td>
        <td class="xl163" colspan="10" style='border-right:none;border-bottom:none;'></td>
       </tr>
       <tr height="36" class="xl66" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl113" height="36" colspan="3" style='height:18.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>其中阅读/写作的时间（小时）：</td>
        <td class="xl115" colspan="5" style='border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;'>
          <input type="number" v-model="myForm.yuedushijian"/>
        </td>
        <td class="xl66" colspan="3" style='mso-ignore:colspan;'></td>
        <td class="xl163" colspan="10" style='mso-ignore:colspan;'></td>
       </tr>
       <tr height="36" class="xl66" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl113" height="36" colspan="3" style='height:18.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>眼睛到书本的距离（cm）：</td>
        <td class="xl115" colspan="5" style='border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;'>
          <input type="number" v-model="myForm.yanjingshubenjuli"/>
        </td>
        <td class="xl66" colspan="3" style='mso-ignore:colspan;'></td>
        <td class="xl163" colspan="10" style='border-right:none;border-bottom:none;'></td>
       </tr>
       <tr height="36" class="xl66" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl109" height="36" colspan="3" style='height:18.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>电脑屏幕高度</td>
        <td class="xl110" colspan="5" style='border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
          <el-radio v-model="myForm.diannaogaodu" label="比眼高">比眼高</el-radio>
          <el-radio v-model="myForm.diannaogaodu" label="与眼平行">与眼平行</el-radio>
          <el-radio v-model="myForm.diannaogaodu" label="比眼低">比眼低</el-radio>
        </td>
        <td class="xl66" colspan="3" style='mso-ignore:colspan;'></td>
        <td class="xl163" colspan="10" style='border-right:none;border-bottom:none;'></td>
       </tr>
       <tr height="36" class="xl66" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl109" height="36" colspan="3" style='height:18.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>有无户外活动</td>
        <td class="xl110" colspan="5" style='border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
          <el-radio v-model="myForm.youwuhuwaihuodong" label="无">无</el-radio>
          <el-radio v-model="myForm.youwuhuwaihuodong" label="有">有</el-radio>
        </td>
        <td class="xl66" colspan="3" style='mso-ignore:colspan;'></td>
        <td class="xl163" colspan="10" style='mso-ignore:colspan;'></td>
       </tr>
       <tr height="36" class="xl66" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl118" height="36" colspan="3" style='height:18.00pt;border-right:.5pt solid windowtext;border-bottom:none;' x:str>每天累计户外活动时间（小时）：</td>
        <td class="xl120" colspan="5" style='border-right:1.0pt solid windowtext;border-bottom:none;'>
          <input type="number" v-model="myForm.meitianhuwaishijian"/>
        </td>
        <td class="xl66" colspan="3" style='mso-ignore:colspan;'></td>
        <td class="xl163" colspan="10" style='mso-ignore:colspan;'></td>
       </tr>
       <tr height="36" class="xl66" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl122" height="36" colspan="8" style='height:18.00pt;border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>家族史</td>
        <td class="xl66" colspan="3" style='mso-ignore:colspan;'></td>
        <td class="xl163" colspan="10" style='border-right:none;border-bottom:none;'></td>
       </tr>
       <tr height="36" class="xl66" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl109" height="36" colspan="2" style='height:18.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>是否早产</td>
        <td class="xl125" colspan="6" style='border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
          <el-radio v-model="myForm.shifouzaochan" label="是">是</el-radio>
          <el-radio v-model="myForm.shifouzaochan" label="否">否</el-radio>
        </td>
        <td class="xl66" colspan="3" style='mso-ignore:colspan;'></td>
        <td class="xl163" colspan="10" style='border-right:none;border-bottom:none;'></td>
       </tr>
       <tr height="36" class="xl66" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl109" height="36" colspan="2" style='height:18.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>父亲是否近视</td>
        <td class="xl125" colspan="6" style='border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
          <el-radio v-model="myForm.shifoufuqinjinshi" label="是">是</el-radio>
          <el-radio v-model="myForm.shifoufuqinjinshi" label="否">否</el-radio>
        </td>
        <td class="xl66" colspan="3" style='mso-ignore:colspan;'></td>
        <td class="xl163" colspan="10" style='mso-ignore:colspan;'></td>
       </tr>
       <tr height="36" class="xl66" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl109" height="36" colspan="2" style='height:18.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>母亲是否近视</td>
        <td class="xl125" colspan="6" style='border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
          <el-radio v-model="myForm.shifoumuqinjinshi" label="是">是</el-radio>
          <el-radio v-model="myForm.shifoumuqinjinshi" label="否">否</el-radio>
        </td>
        <td class="xl66" colspan="3" style='mso-ignore:colspan;'></td>
        <td class="xl163" colspan="10" style='border-right:none;border-bottom:none;'></td>
       </tr>
       <tr height="36" class="xl66" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl109" height="36" colspan="2" style='height:18.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>如果近视，属于</td>
        <td class="xl125" colspan="6" style='border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
          <el-radio v-model="myForm.jinshichengdu" label="低度近视">低度近视（<300度）</el-radio>
          <el-radio v-model="myForm.jinshichengdu" label="中度近视">中度近视（300~600）</el-radio>
          <el-radio v-model="myForm.jinshichengdu" label="高度近视">高度近视（>600度）</el-radio>
        </td>
        <td class="xl66" colspan="3" style='mso-ignore:colspan;'></td>
        <td class="xl164" colspan="10" style='border-right:none;border-bottom:none;'></td>
       </tr>
       <tr height="36" class="xl66" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl127" height="36" colspan="2" style='height:18.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>是否有眼部或视力疾病</td>
        <td class="xl129" colspan="6" style='border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
          <el-checkbox-group v-model="myForm.shifouyoujibing">
            <el-checkbox label="无"></el-checkbox>
            <el-checkbox label="斜视"></el-checkbox>
            <el-checkbox label="弱视"></el-checkbox>
            <el-checkbox label="眼球震颤"></el-checkbox>
            <el-checkbox label="上睑下垂"></el-checkbox>
          </el-checkbox-group>
        </td>
        <td class="xl66" colspan="3" style='mso-ignore:colspan;'></td>
        <td class="xl165" colspan="10" style='mso-ignore:colspan;'></td>
       </tr>
       <tr height="36" class="xl66" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl109" height="36" colspan="2" style='height:18.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>眼部手术史：</td>
        <td class="xl132" colspan="6" style='border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;'>
          <input type="text" v-model="myForm.yanbushoushushi"/>
        </td>
        <td class="xl66" colspan="3" style='mso-ignore:colspan;'></td>
        <td class="xl165" colspan="10" style='mso-ignore:colspan;'></td>
       </tr>
       <tr height="36" class="xl66" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl134" height="36" colspan="2" style='height:18.00pt;border-right:.5pt solid windowtext;border-bottom:1.0pt solid windowtext;' x:str>屈光手术史：</td>
        <td class="xl136" colspan="6" style='border-right:1.0pt solid windowtext;border-bottom:1.0pt solid windowtext;'>
          <input type="text" v-model="myForm.quguangshoushushi"/>
        </td>
        <td class="xl166" colspan="5" style='mso-ignore:colspan;'></td>
        <td class="xl165" colspan="8" style='mso-ignore:colspan;'></td>
       </tr>
       <tr height="36" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl138" height="36" colspan="8" style='height:18.00pt;border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>视觉行为与视觉品质评估问卷</td>
        <td class="xl69" colspan="13" style='mso-ignore:colspan;'></td>
       </tr>
       <tr height="36" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl141" height="36" colspan="3" style='height:18.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>您日常是否有眼睛疲劳的症状？</td>
        <td class="xl143" colspan="5" style='border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
          <el-radio v-model="myForm.shifouyanjingpilao" label="偶尔">偶尔</el-radio>
          <el-radio v-model="myForm.shifouyanjingpilao" label="经常">经常</el-radio>
          <el-radio v-model="myForm.shifouyanjingpilao" label="否">否</el-radio>
        </td>
        <td class="xl69" colspan="13" style='mso-ignore:colspan;'></td>
       </tr>
       <tr height="72" style='height:36.00pt;mso-height-source:userset;mso-height-alt:720;'>
        <td class="xl145" height="72" colspan="8" style='height:36.00pt;border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>选项：1.从不　2.有时　3.经常　4.频繁（0分、1分、2分、3分）<br/>评分大于16分则提示有视功能异常，需通过相关的视功能检查发现问题并对症训练。</td>
        <td class="xl69" colspan="13" style='mso-ignore:colspan;'></td>
       </tr>
       <tr height="36" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl148" height="36" colspan="5" style='height:18.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>内容</td>
        <td class="xl151" colspan="3" style='border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>选项</td>
        <td class="xl69" colspan="13" style='mso-ignore:colspan;'></td>
       </tr>
       <tr height="36" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl145" height="36" colspan="5" style='height:18.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>1.阅读或近距离工作时你是否觉得眼部疲劳或不适？</td>
        <td class="xl151" colspan="3" style='border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong1" label="从不">从不</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong1" label="有时">有时</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong1" label="经常">经常</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong1" label="频繁">频繁</el-radio>
        </td>
        <td class="xl69" colspan="13" style='mso-ignore:colspan;'></td>
       </tr>
       <tr height="36" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl145" height="36" colspan="5" style='height:18.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>2.阅读或近距离工作时你有否头痛？</td>
        <td class="xl151" colspan="3" style='border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong2" label="从不">从不</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong2" label="有时">有时</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong2" label="经常">经常</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong2" label="频繁">频繁</el-radio>
        </td>
        <td class="xl69" colspan="13" style='mso-ignore:colspan;'></td>
       </tr>
       <tr height="36" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl145" height="36" colspan="5" style='height:18.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>3.阅读或近距离工作时你是否觉得易困乏？</td>
        <td class="xl151" colspan="3" style='border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong3" label="从不">从不</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong3" label="有时">有时</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong3" label="经常">经常</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong3" label="频繁">频繁</el-radio>
        </td>
        <td class="xl69" colspan="13" style='mso-ignore:colspan;'></td>
       </tr>
       <tr height="36" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl145" height="36" colspan="5" style='height:18.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>4.阅读或近距离工作时，你的注意力是否不集中？</td>
        <td class="xl151" colspan="3" style='border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong4" label="从不">从不</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong4" label="有时">有时</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong4" label="经常">经常</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong4" label="频繁">频繁</el-radio>
        </td>
        <td class="xl69" colspan="13" style='mso-ignore:colspan;'></td>
       </tr>
       <tr height="36" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl145" height="36" colspan="5" style='height:18.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>5.你是否对记住读过的东西感到困难？</td>
        <td class="xl151" colspan="3" style='border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong5" label="从不">从不</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong5" label="有时">有时</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong5" label="经常">经常</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong5" label="频繁">频繁</el-radio>
        </td>
        <td class="xl69" colspan="13" style='mso-ignore:colspan;'></td>
       </tr>
       <tr height="36" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl145" height="36" colspan="5" style='height:18.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>6.阅读或近距离工作时是否会出现双影？</td>
        <td class="xl151" colspan="3" style='border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong6" label="从不">从不</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong6" label="有时">有时</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong6" label="经常">经常</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong6" label="频繁">频繁</el-radio>
        </td>
        <td class="xl69" colspan="13" style='mso-ignore:colspan;'></td>
       </tr>
       <tr height="36" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl145" height="36" colspan="5" style='height:18.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>7.阅读或近距离工作时你是否觉得文字移动、跳动、游动或在纸面上漂浮？</td>
        <td class="xl151" colspan="3" style='border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong7" label="从不">从不</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong7" label="有时">有时</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong7" label="经常">经常</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong7" label="频繁">频繁</el-radio>
        </td>
        <td class="xl69" colspan="13" style='mso-ignore:colspan;'></td>
       </tr>
       <tr height="36" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl145" height="36" colspan="5" style='height:18.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>8.你是否觉得你的阅读速度慢？</td>
        <td class="xl151" colspan="3" style='border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong8" label="从不">从不</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong8" label="有时">有时</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong8" label="经常">经常</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong8" label="频繁">频繁</el-radio>
        </td>
        <td class="xl69" colspan="13" style='mso-ignore:colspan;'></td>
       </tr>
       <tr height="36" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl145" height="36" colspan="5" style='height:18.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>9.阅读或近距离工作时你是否觉得眼痛、眼酸？</td>
        <td class="xl151" colspan="3" style='border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong9" label="从不">从不</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong9" label="有时">有时</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong9" label="经常">经常</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong9" label="频繁">频繁</el-radio>
        </td>
        <td class="xl69" colspan="13" style='mso-ignore:colspan;'></td>
       </tr>
       <tr height="36" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl145" height="36" colspan="5" style='height:18.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>10.阅读或近距离工作时你是否有一种眼球“脱出”感？</td>
        <td class="xl151" colspan="3" style='border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong10" label="从不">从不</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong10" label="有时">有时</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong10" label="经常">经常</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong10" label="频繁">频繁</el-radio>
        </td>
        <td class="xl69" colspan="13" style='mso-ignore:colspan;'></td>
       </tr>
       <tr height="36" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl145" height="36" colspan="5" style='height:18.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>11.阅读或近距离工作时你是否会出现视物模糊？</td>
        <td class="xl151" colspan="3" style='border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong11" label="从不">从不</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong11" label="有时">有时</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong11" label="经常">经常</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong11" label="频繁">频繁</el-radio>
        </td>
        <td class="xl69" colspan="13" style='mso-ignore:colspan;'></td>
       </tr>
       <tr height="36" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl145" height="36" colspan="5" style='height:18.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>12.阅读或近距离工作时你是否会“串行”？</td>
        <td class="xl151" colspan="3" style='border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong12" label="从不">从不</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong12" label="有时">有时</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong12" label="经常">经常</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong12" label="频繁">频繁</el-radio>
        </td>
        <td class="xl69" colspan="13" style='mso-ignore:colspan;'></td>
       </tr>
       <tr height="36" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl145" height="36" colspan="5" style='height:18.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>13.阅读或近距离工作时你是否不得不重复读同一行？</td>
        <td class="xl151" colspan="3" style='border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong13" label="从不">从不</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong13" label="有时">有时</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong13" label="经常">经常</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong13" label="频繁">频繁</el-radio>
        </td>
        <td class="xl69" colspan="13" style='mso-ignore:colspan;'></td>
       </tr>
       <tr height="36" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl145" height="36" colspan="5" style='height:18.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>14.你是否回避阅读或近距离工作？</td>
        <td class="xl151" colspan="3" style='border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong14" label="从不">从不</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong14" label="有时">有时</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong14" label="经常">经常</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong14" label="频繁">频繁</el-radio>
        </td>
        <td class="xl69" colspan="13" style='mso-ignore:colspan;'></td>
       </tr>
       <tr height="36" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl145" height="36" colspan="5" style='height:18.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>15.你是否从视远转到视近或从视近转到视远聚焦困难？</td>
        <td class="xl151" colspan="3" style='border-right:1.0pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong15" label="从不">从不</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong15" label="有时">有时</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong15" label="经常">经常</el-radio>
          <el-radio @input="processWenJuanNeiRong" v-model="myForm.neirong15" label="频繁">频繁</el-radio>
        </td>
        <td class="xl69" colspan="13" style='mso-ignore:colspan;'></td>
       </tr>
       <tr height="36" style='height:18.00pt;mso-height-source:userset;mso-height-alt:360;'>
        <td class="xl154" height="36" colspan="5" style='height:18.00pt;border-right:.5pt solid windowtext;border-bottom:1.0pt solid windowtext;' x:str>问卷评分</td>
        <td class="xl157" colspan="3" style='border-right:1.0pt solid windowtext;border-bottom:1.0pt solid windowtext;'>
          <!-- <input type="text" v-model="myForm.wenjuanpingfen"/> -->
          {{myForm.wenjuanpingfen}}
        </td>
        <td class="xl69" colspan="13" style='mso-ignore:colspan;'></td>
       </tr>
       <![if supportMisalignedColumns]>
        <tr width="0" style='display:none;'>
         <td width="117" style='width:59;'></td>
         <td width="117" style='width:59;'></td>
         <td width="117" style='width:59;'></td>
         <td width="99" style='width:50;'></td>
        </tr>
       <![endif]>
      </table>
    </div>
    <div class="addbutton">
      <el-button type="primary" v-if="processingMode == 1" @click="clickAdd">添加</el-button>
      <el-button type="primary" v-if="processingMode == 3" @click="clickModify">修改</el-button>
      <el-button type="info" @click="clickBack">返回</el-button>
      <el-button type="primary" @click="clicksavepic">下载</el-button>
    </div>
  </div>
</template>

<script>
import html2canvas from 'html2canvas'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data() {
    return {
      Name: "基本信息",
      //1添加;2查看;3修改
      processingMode: 1,
      myFormBack: null,
      myForm:{
        id: "0",
        glassuserid: "0",
        name: "",
        sex: "",
        age: "",
        phone: "",
        jianchayuanyin: [],
        shangcijianchariqi: "",
        shoucixiajiangage: "",
        daijingshi: "",
        daijingleixing: [],
        meiniandushugaibian: "",
        genghuanyanjingzhouqi: "",
        richangshiyexuqiu: [],
        meitianjinjuli: "",
        yuedushijian: "",
        yanjingshubenjuli: "",
        diannaogaodu: "",
        youwuhuwaihuodong: "",
        meitianhuwaishijian: "",
        shifouzaochan: "",
        shifoufuqinjinshi: "",
        shifoumuqinjinshi: "",
        jinshichengdu: "",
        shifouyoujibing: [],
        yanbushoushushi: "",
        quguangshoushushi: "",
        shifouyanjingpilao: "",
        neirong1: "",
        neirong2: "",
        neirong3: "",
        neirong4: "",
        neirong5: "",
        neirong6: "",
        neirong7: "",
        neirong8: "",
        neirong9: "",
        neirong10: "",
        neirong11: "",
        neirong12: "",
        neirong13: "",
        neirong14: "",
        neirong15: "",
        wenjuanpingfen: 0
      }
    };
  },
  mounted () {
  },
  methods: {
    clickBack () {
      this.$emit('triggerFunc', '')
    },
    clicksavepic () {
      var that = this
      html2canvas(that.$refs.box, {
        useCORS: true,
        allowTaint: false
      }).then(function (canvas) {
        var a = document.createElement('a')
        a.href = canvas.toDataURL('image/jpeg')
        a.download = that.Name
        a.click()
        a.remove()
      })
    },
    initData (glassuserid) {
      this.myForm.glassuserid = glassuserid
      this.myFormBack = Vue.prototype.CloneObj(this.myForm)
    },
    editMode(row){
      this.processingMode = 3
      this.myForm.id = row.Id
      this.myForm.name = row.Name
      this.myForm.sex = row.Sex
      this.myForm.age = row.Age
      this.myForm.phone = row.Phone
      this.myForm.jianchayuanyin = row.Jianchayuanyin.split(",")
      this.myForm.shangcijianchariqi = row.Shangcijianchariqi
      this.myForm.shoucixiajiangage = row.Shoucixiajiangage
      this.myForm.daijingshi = row.Daijingshi
      this.myForm.daijingleixing = row.Daijingleixing.split(",")
      this.myForm.meiniandushugaibian = row.Meiniandushugaibian
      this.myForm.genghuanyanjingzhouqi = row.Genghuanyanjingzhouqi
      this.myForm.richangshiyexuqiu = row.Richangshiyexuqiu.split(",")
      this.myForm.meitianjinjuli = row.Meitianjinjuli
      this.myForm.yuedushijian = row.Yuedushijian
      this.myForm.yanjingshubenjuli = row.Yanjingshubenjuli
      this.myForm.diannaogaodu = row.Diannaogaodu
      this.myForm.youwuhuwaihuodong = row.Youwuhuwaihuodong
      this.myForm.meitianhuwaishijian = row.Meitianhuwaishijian
      this.myForm.shifouzaochan = row.Shifouzaochan
      this.myForm.shifoufuqinjinshi = row.Shifoufuqinjinshi
      this.myForm.shifoumuqinjinshi = row.Shifoumuqinjinshi
      this.myForm.jinshichengdu = row.Jinshichengdu
      this.myForm.shifouyoujibing = row.Shifouyoujibing.split(",")
      this.myForm.yanbushoushushi = row.Yanbushoushushi
      this.myForm.quguangshoushushi = row.Quguangshoushushi
      this.myForm.shifouyanjingpilao = row.Shifouyanjingpilao
      this.myForm.neirong1 = row.Neirong1
      this.myForm.neirong2 = row.Neirong2
      this.myForm.neirong3 = row.Neirong3
      this.myForm.neirong4 = row.Neirong4
      this.myForm.neirong5 = row.Neirong5
      this.myForm.neirong6 = row.Neirong6
      this.myForm.neirong7 = row.Neirong7
      this.myForm.neirong8 = row.Neirong8
      this.myForm.neirong9 = row.Neirong9
      this.myForm.neirong10 = row.Neirong10
      this.myForm.neirong11 = row.Neirong11
      this.myForm.neirong12 = row.Neirong12
      this.myForm.neirong13 = row.Neirong13
      this.myForm.neirong14 = row.Neirong14
      this.myForm.neirong15 = row.Neirong15
      this.myForm.wenjuanpingfen = row.Wenjuanpingfen
    },
    clickAdd () {
      this.$confirm('您确定需要添加吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiAddErp7ShiGuangJiBenXinXi()
      })
    },
    clickModify () {
      this.apiEditErp7ShiGuangJiBenXinXi()
    },
    processWenJuanNeiRong() {
      this.myForm.wenjuanpingfen = 0
      this.myForm.wenjuanpingfen += this.processWenJuanNeiRongSub(this.myForm.neirong1)
      this.myForm.wenjuanpingfen += this.processWenJuanNeiRongSub(this.myForm.neirong2)
      this.myForm.wenjuanpingfen += this.processWenJuanNeiRongSub(this.myForm.neirong3)
      this.myForm.wenjuanpingfen += this.processWenJuanNeiRongSub(this.myForm.neirong4)
      this.myForm.wenjuanpingfen += this.processWenJuanNeiRongSub(this.myForm.neirong5)
      this.myForm.wenjuanpingfen += this.processWenJuanNeiRongSub(this.myForm.neirong6)
      this.myForm.wenjuanpingfen += this.processWenJuanNeiRongSub(this.myForm.neirong7)
      this.myForm.wenjuanpingfen += this.processWenJuanNeiRongSub(this.myForm.neirong8)
      this.myForm.wenjuanpingfen += this.processWenJuanNeiRongSub(this.myForm.neirong9)
      this.myForm.wenjuanpingfen += this.processWenJuanNeiRongSub(this.myForm.neirong10)
      this.myForm.wenjuanpingfen += this.processWenJuanNeiRongSub(this.myForm.neirong11)
      this.myForm.wenjuanpingfen += this.processWenJuanNeiRongSub(this.myForm.neirong12)
      this.myForm.wenjuanpingfen += this.processWenJuanNeiRongSub(this.myForm.neirong13)
      this.myForm.wenjuanpingfen += this.processWenJuanNeiRongSub(this.myForm.neirong14)
      this.myForm.wenjuanpingfen += this.processWenJuanNeiRongSub(this.myForm.neirong15)
    },
    processWenJuanNeiRongSub(neirong) {
      //选项：1.从不　2.有时　3.经常　4.频繁（0分、1分、2分、3分）
      if(neirong == "有时"){
        return 1;
      }
      if(neirong == "经常"){
        return 2;
      }
      if(neirong == "频繁"){
        return 3;
      }
      return 0;
    },
    apiAddErp7ShiGuangJiBenXinXi: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      var myFormBuf = Vue.prototype.CloneObj(that.myForm)
      myFormBuf.jianchayuanyin = that.myForm.jianchayuanyin.toString()
      myFormBuf.daijingleixing = that.myForm.daijingleixing.toString()
      myFormBuf.richangshiyexuqiu = that.myForm.richangshiyexuqiu.toString()
      myFormBuf.shifouyoujibing = that.myForm.shifouyoujibing.toString()
      data = { ...data, ...myFormBuf }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddErp7ShiGuangJiBenXinXi, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.myForm = Vue.prototype.CloneObj(that.myFormBack)
            that.$emit('triggerFunc', '')
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditErp7ShiGuangJiBenXinXi: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      var myFormBuf = Vue.prototype.CloneObj(that.myForm)
      myFormBuf.jianchayuanyin = that.myForm.jianchayuanyin.toString()
      myFormBuf.daijingleixing = that.myForm.daijingleixing.toString()
      myFormBuf.richangshiyexuqiu = that.myForm.richangshiyexuqiu.toString()
      myFormBuf.shifouyoujibing = that.myForm.shifouyoujibing.toString()
      data = { ...data, ...myFormBuf }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditErp7ShiGuangJiBenXinXi, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
  },
};
</script>

<style scoped>
@page
	{margin:0.35in 0.16in 0.20in 0.67in;
	mso-header-margin:0.50in;
	mso-footer-margin:0.12in;}
tr
	{mso-height-source:auto;
	mso-ruby-visibility:none;}
col
	{mso-width-source:auto;
	mso-ruby-visibility:none;}
br
	{mso-data-placement:same-cell;}
input{
     border: none;
     outline:medium;
     text-align:center;
     overflow: hidden;
     height: 100%;
     width: 95%;
  }
.addbutton{
  position: fixed;
  top: 50vh;
  right: 60px;
}
.font0
	{color:#000000;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:"宋体";
	mso-generic-font-family:auto;
	mso-font-charset:134;}
.font1
	{color:#000000;
	font-size:12.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:"宋体";
	mso-generic-font-family:auto;
	mso-font-charset:134;}
.font2
	{color:#000000;
	font-size:12.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:"宋体";
	mso-generic-font-family:auto;
	mso-font-charset:134;}
.font3
	{color:#000000;
	font-size:12.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:"宋体";
	mso-generic-font-family:auto;
	mso-font-charset:134;}
.font4
	{color:#000000;
	font-size:18.0pt;
	font-weight:700;
	font-style:normal;
	text-decoration:none;
	font-family:"宋体";
	mso-generic-font-family:auto;
	mso-font-charset:134;}
.font5
	{color:#000000;
	font-size:10.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:"宋体";
	mso-generic-font-family:auto;
	mso-font-charset:134;}
.font6
	{color:#000000;
	font-size:14.0pt;
	font-weight:700;
	font-style:normal;
	text-decoration:none;
	font-family:"宋体";
	mso-generic-font-family:auto;
	mso-font-charset:134;}
.font7
	{color:#000000;
	font-size:11.0pt;
	font-weight:700;
	font-style:normal;
	text-decoration:none;
	font-family:"宋体";
	mso-generic-font-family:auto;
	mso-font-charset:134;}
.font8
	{color:#000000;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:"宋体";
	mso-generic-font-family:auto;
	mso-font-charset:134;}
.font9
	{color:#000000;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:"宋体";
	mso-generic-font-family:auto;
	mso-font-charset:134;}
.font10
	{color:#000000;
	font-size:14.0pt;
	font-weight:700;
	font-style:normal;
	text-decoration:none;
	font-family:"宋体";
	mso-generic-font-family:auto;
	mso-font-charset:134;}
.font11
	{color:#000000;
	font-size:12.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:"微软雅黑";
	mso-generic-font-family:swiss;
	mso-font-charset:134;}
.font12
	{color:#0000FF;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:underline;
	text-underline-style:single;
	font-family:"宋体";
	mso-generic-font-family:auto;
	mso-font-charset:134;}
.font13
	{color:#800080;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:underline;
	text-underline-style:single;
	font-family:"宋体";
	mso-generic-font-family:auto;
	mso-font-charset:134;}
.font14
	{color:#FF0000;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:"宋体";
	mso-generic-font-family:auto;
	mso-font-charset:134;}
.font15
	{color:#44546A;
	font-size:18.0pt;
	font-weight:700;
	font-style:normal;
	text-decoration:none;
	font-family:"宋体";
	mso-generic-font-family:auto;
	mso-font-charset:134;}
.font16
	{color:#7F7F7F;
	font-size:11.0pt;
	font-weight:400;
	font-style:italic;
	text-decoration:none;
	font-family:"宋体";
	mso-generic-font-family:auto;
	mso-font-charset:134;}
.font17
	{color:#44546A;
	font-size:15.0pt;
	font-weight:700;
	font-style:normal;
	text-decoration:none;
	font-family:"宋体";
	mso-generic-font-family:auto;
	mso-font-charset:134;}
.font18
	{color:#44546A;
	font-size:13.0pt;
	font-weight:700;
	font-style:normal;
	text-decoration:none;
	font-family:"宋体";
	mso-generic-font-family:auto;
	mso-font-charset:134;}
.font19
	{color:#44546A;
	font-size:11.0pt;
	font-weight:700;
	font-style:normal;
	text-decoration:none;
	font-family:"宋体";
	mso-generic-font-family:auto;
	mso-font-charset:134;}
.font20
	{color:#3F3F76;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:"宋体";
	mso-generic-font-family:auto;
	mso-font-charset:134;}
.font21
	{color:#3F3F3F;
	font-size:11.0pt;
	font-weight:700;
	font-style:normal;
	text-decoration:none;
	font-family:"宋体";
	mso-generic-font-family:auto;
	mso-font-charset:134;}
.font22
	{color:#FA7D00;
	font-size:11.0pt;
	font-weight:700;
	font-style:normal;
	text-decoration:none;
	font-family:"宋体";
	mso-generic-font-family:auto;
	mso-font-charset:134;}
.font23
	{color:#FFFFFF;
	font-size:11.0pt;
	font-weight:700;
	font-style:normal;
	text-decoration:none;
	font-family:"宋体";
	mso-generic-font-family:auto;
	mso-font-charset:134;}
.font24
	{color:#FA7D00;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:"宋体";
	mso-generic-font-family:auto;
	mso-font-charset:134;}
.font25
	{color:#000000;
	font-size:11.0pt;
	font-weight:700;
	font-style:normal;
	text-decoration:none;
	font-family:"宋体";
	mso-generic-font-family:auto;
	mso-font-charset:134;}
.font26
	{color:#006100;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:"宋体";
	mso-generic-font-family:auto;
	mso-font-charset:134;}
.font27
	{color:#9C0006;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:"宋体";
	mso-generic-font-family:auto;
	mso-font-charset:134;}
.font28
	{color:#9C6500;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:"宋体";
	mso-generic-font-family:auto;
	mso-font-charset:134;}
.font29
	{color:#FFFFFF;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:"宋体";
	mso-generic-font-family:auto;
	mso-font-charset:134;}
.style0
	{mso-number-format:"General";
	text-align:general;
	vertical-align:middle;
	white-space:nowrap;
	mso-rotate:0;
	mso-pattern:auto;
	mso-background-source:auto;
	color:#000000;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	border:none;
	mso-protection:locked visible;
	mso-style-name:"常规";
	mso-style-id:0;}
.style16
	{mso-number-format:"_ * \#\,\#\#0\.00_ \;_ * \\-\#\,\#\#0\.00_ \;_ * \0022-\0022??_ \;_ \@_ ";
	mso-style-name:"千位分隔";
	mso-style-id:3;}
.style17
	{mso-number-format:"_ \0022\00A5\0022* \#\,\#\#0\.00_ \;_ \0022\00A5\0022* \\-\#\,\#\#0\.00_ \;_ \0022\00A5\0022* \0022-\0022??_ \;_ \@_ ";
	mso-style-name:"货币";
	mso-style-id:4;}
.style18
	{mso-number-format:"0%";
	mso-style-name:"百分比";
	mso-style-id:5;}
.style19
	{mso-number-format:"_ * \#\,\#\#0_ \;_ * \\-\#\,\#\#0_ \;_ * \0022-\0022_ \;_ \@_ ";
	mso-style-name:"千位分隔[0]";
	mso-style-id:6;}
.style20
	{mso-number-format:"_ \0022\00A5\0022* \#\,\#\#0_ \;_ \0022\00A5\0022* \\-\#\,\#\#0_ \;_ \0022\00A5\0022* \0022-\0022_ \;_ \@_ ";
	mso-style-name:"货币[0]";
	mso-style-id:7;}
.style21
	{color:#0000FF;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:underline;
	text-underline-style:single;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	mso-style-name:"超链接";
	mso-style-id:8;}
.style22
	{color:#800080;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:underline;
	text-underline-style:single;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	mso-style-name:"已访问的超链接";
	mso-style-id:9;}
.style23
	{mso-pattern:auto none;
	background:#FFFFCC;
	border:.5pt solid #B2B2B2;
	mso-style-name:"注释";}
.style24
	{color:#FF0000;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	mso-style-name:"警告文本";}
.style25
	{color:#44546A;
	font-size:18.0pt;
	font-weight:700;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	mso-style-name:"标题";}
.style26
	{color:#7F7F7F;
	font-size:11.0pt;
	font-weight:400;
	font-style:italic;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	mso-style-name:"解释性文本";}
.style27
	{color:#44546A;
	font-size:15.0pt;
	font-weight:700;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	border-left:none;
	border-top:none;
	border-right:none;
	border-bottom:1.0pt solid #5B9BD5;
	mso-style-name:"标题 1";}
.style28
	{color:#44546A;
	font-size:13.0pt;
	font-weight:700;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	border-left:none;
	border-top:none;
	border-right:none;
	border-bottom:1.0pt solid #5B9BD5;
	mso-style-name:"标题 2";}
.style29
	{color:#44546A;
	font-size:11.0pt;
	font-weight:700;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	border-left:none;
	border-top:none;
	border-right:none;
	border-bottom:1.0pt solid #ACCCEA;
	mso-style-name:"标题 3";}
.style30
	{color:#44546A;
	font-size:11.0pt;
	font-weight:700;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	mso-style-name:"标题 4";}
.style31
	{mso-pattern:auto none;
	background:#FFCC99;
	color:#3F3F76;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	border:.5pt solid #7F7F7F;
	mso-style-name:"输入";}
.style32
	{mso-pattern:auto none;
	background:#F2F2F2;
	color:#3F3F3F;
	font-size:11.0pt;
	font-weight:700;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	border:.5pt solid #3F3F3F;
	mso-style-name:"输出";}
.style33
	{mso-pattern:auto none;
	background:#F2F2F2;
	color:#FA7D00;
	font-size:11.0pt;
	font-weight:700;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	border:.5pt solid #7F7F7F;
	mso-style-name:"计算";}
.style34
	{mso-pattern:auto none;
	background:#A5A5A5;
	color:#FFFFFF;
	font-size:11.0pt;
	font-weight:700;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	border:2.0pt double #3F3F3F;
	mso-style-name:"检查单元格";}
.style35
	{color:#FA7D00;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	border-left:none;
	border-top:none;
	border-right:none;
	border-bottom:2.0pt double #FF8001;
	mso-style-name:"链接单元格";}
.style36
	{color:#000000;
	font-size:11.0pt;
	font-weight:700;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	border-left:none;
	border-top:.5pt solid #5B9BD5;
	border-right:none;
	border-bottom:2.0pt double #5B9BD5;
	mso-style-name:"汇总";}
.style37
	{mso-pattern:auto none;
	background:#C6EFCE;
	color:#006100;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	mso-style-name:"好";}
.style38
	{mso-pattern:auto none;
	background:#FFC7CE;
	color:#9C0006;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	mso-style-name:"差";}
.style39
	{mso-pattern:auto none;
	background:#FFEB9C;
	color:#9C6500;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	mso-style-name:"适中";}
.style40
	{mso-pattern:auto none;
	background:#5B9BD5;
	color:#FFFFFF;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	mso-style-name:"强调文字颜色 1";}
.style41
	{mso-pattern:auto none;
	background:#DDEBF7;
	color:#000000;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	mso-style-name:"20% - 强调文字颜色 1";}
.style42
	{mso-pattern:auto none;
	background:#BDD7EE;
	color:#000000;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	mso-style-name:"40% - 强调文字颜色 1";}
.style43
	{mso-pattern:auto none;
	background:#9BC2E6;
	color:#FFFFFF;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	mso-style-name:"60% - 强调文字颜色 1";}
.style44
	{mso-pattern:auto none;
	background:#ED7D31;
	color:#FFFFFF;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	mso-style-name:"强调文字颜色 2";}
.style45
	{mso-pattern:auto none;
	background:#FCE4D6;
	color:#000000;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	mso-style-name:"20% - 强调文字颜色 2";}
.style46
	{mso-pattern:auto none;
	background:#F8CBAD;
	color:#000000;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	mso-style-name:"40% - 强调文字颜色 2";}
.style47
	{mso-pattern:auto none;
	background:#F4B084;
	color:#FFFFFF;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	mso-style-name:"60% - 强调文字颜色 2";}
.style48
	{mso-pattern:auto none;
	background:#A5A5A5;
	color:#FFFFFF;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	mso-style-name:"强调文字颜色 3";}
.style49
	{mso-pattern:auto none;
	background:#EDEDED;
	color:#000000;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	mso-style-name:"20% - 强调文字颜色 3";}
.style50
	{mso-pattern:auto none;
	background:#DBDBDB;
	color:#000000;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	mso-style-name:"40% - 强调文字颜色 3";}
.style51
	{mso-pattern:auto none;
	background:#C9C9C9;
	color:#FFFFFF;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	mso-style-name:"60% - 强调文字颜色 3";}
.style52
	{mso-pattern:auto none;
	background:#FFC000;
	color:#FFFFFF;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	mso-style-name:"强调文字颜色 4";}
.style53
	{mso-pattern:auto none;
	background:#FFF2CC;
	color:#000000;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	mso-style-name:"20% - 强调文字颜色 4";}
.style54
	{mso-pattern:auto none;
	background:#FFE699;
	color:#000000;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	mso-style-name:"40% - 强调文字颜色 4";}
.style55
	{mso-pattern:auto none;
	background:#FFD966;
	color:#FFFFFF;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	mso-style-name:"60% - 强调文字颜色 4";}
.style56
	{mso-pattern:auto none;
	background:#4472C4;
	color:#FFFFFF;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	mso-style-name:"强调文字颜色 5";}
.style57
	{mso-pattern:auto none;
	background:#D9E1F2;
	color:#000000;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	mso-style-name:"20% - 强调文字颜色 5";}
.style58
	{mso-pattern:auto none;
	background:#B4C6E7;
	color:#000000;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	mso-style-name:"40% - 强调文字颜色 5";}
.style59
	{mso-pattern:auto none;
	background:#8EA9DB;
	color:#FFFFFF;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	mso-style-name:"60% - 强调文字颜色 5";}
.style60
	{mso-pattern:auto none;
	background:#70AD47;
	color:#FFFFFF;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	mso-style-name:"强调文字颜色 6";}
.style61
	{mso-pattern:auto none;
	background:#E2EFDA;
	color:#000000;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	mso-style-name:"20% - 强调文字颜色 6";}
.style62
	{mso-pattern:auto none;
	background:#C6E0B4;
	color:#000000;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	mso-style-name:"40% - 强调文字颜色 6";}
.style63
	{mso-pattern:auto none;
	background:#A9D08E;
	color:#FFFFFF;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	mso-style-name:"60% - 强调文字颜色 6";}
.style64
	{mso-number-format:"General";
	text-align:general;
	vertical-align:middle;
	white-space:nowrap;
	mso-rotate:0;
	mso-pattern:auto;
	mso-background-source:auto;
	color:#000000;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	border:none;
	mso-protection:locked visible;
	mso-style-name:"常规 2";}
td
	{mso-style-parent:style0;
	padding-top:1px;
	padding-right:1px;
	padding-left:1px;
	mso-ignore:padding;
	mso-number-format:"General";
	text-align:general;
	vertical-align:middle;
	white-space:nowrap;
	mso-rotate:0;
	mso-pattern:auto;
	mso-background-source:auto;
	color:#000000;
	font-size:11.0pt;
	font-weight:400;
	font-style:normal;
	text-decoration:none;
	font-family:宋体;
	mso-generic-font-family:auto;
	mso-font-charset:134;
	border:none;
	mso-protection:locked visible;}
.xl66
	{mso-style-parent:style0;
	font-size:12.0pt;
	mso-font-charset:134;}
.xl67
	{mso-style-parent:style0;
	text-align:center;
	font-size:12.0pt;
	mso-font-charset:134;}
.xl68
	{mso-style-parent:style0;
	font-size:12.0pt;
	mso-font-charset:134;}
.xl69
	{mso-style-parent:style0;
	font-size:12.0pt;
	mso-font-charset:134;}
.xl70
	{mso-style-parent:style0;
	text-align:center;
	font-size:18.0pt;
	font-weight:700;
	mso-font-charset:134;
	border-left:1.0pt solid windowtext;
	border-top:1.0pt solid windowtext;
	border-right:.5pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl71
	{mso-style-parent:style0;
	text-align:center;
	font-size:18.0pt;
	font-weight:700;
	mso-font-charset:134;
	border-left:.5pt solid windowtext;
	border-top:1.0pt solid windowtext;
	border-right:.5pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl72
	{mso-style-parent:style0;
	text-align:center;
	font-size:18.0pt;
	font-weight:700;
	mso-font-charset:134;
	border-left:.5pt solid windowtext;
	border-top:1.0pt solid windowtext;
	border-right:1.0pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl73
	{mso-style-parent:style0;
	text-align:left;
	mso-font-charset:134;
	border-left:1.0pt solid windowtext;
	border-right:.5pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl74
	{mso-style-parent:style0;
	text-align:left;
	mso-font-charset:134;
	border-left:.5pt solid windowtext;
	border-right:.5pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl75
	{mso-style-parent:style0;
	text-align:left;
	mso-font-charset:134;
	border-left:.5pt solid windowtext;
	border-right:.5pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl76
	{mso-style-parent:style0;
	font-size:10.0pt;
	mso-font-charset:134;
	border-left:.5pt solid windowtext;
	border-top:.5pt solid windowtext;
	border-right:1.0pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl77
	{mso-style-parent:style0;
	text-align:center;
	font-size:14.0pt;
	font-weight:700;
	mso-font-charset:134;
	border-left:1.0pt solid windowtext;
	border-top:.5pt solid windowtext;
	border-bottom:1.0pt solid windowtext;}
.xl78
	{mso-style-parent:style0;
	text-align:center;
	font-size:14.0pt;
	font-weight:700;
	mso-font-charset:134;
	border-top:.5pt solid windowtext;
	border-bottom:1.0pt solid windowtext;}
.xl79
	{mso-style-parent:style0;
	text-align:center;
	font-size:14.0pt;
	font-weight:700;
	mso-font-charset:134;
	border-top:.5pt solid windowtext;
	border-right:1.0pt solid windowtext;
	border-bottom:1.0pt solid windowtext;}
.xl80
	{mso-style-parent:style0;
	text-align:center;
	white-space:normal;
	font-weight:700;
	mso-font-charset:134;
	border-left:1.0pt solid windowtext;
	border-top:1.0pt solid windowtext;
	border-right:.5pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl81
	{mso-style-parent:style0;
	text-align:center;
	white-space:normal;
	font-weight:700;
	mso-font-charset:134;
	border-left:.5pt solid windowtext;
	border-top:1.0pt solid windowtext;
	border-right:.5pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl82
	{mso-style-parent:style0;
	text-align:center;
	white-space:normal;
	font-weight:700;
	mso-font-charset:134;
	border-left:.5pt solid windowtext;
	border-top:1.0pt solid windowtext;
	border-right:1.0pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl83
	{mso-style-parent:style0;
	text-align:center;
	white-space:normal;
	mso-font-charset:134;
	border-left:1.0pt solid windowtext;
	border-top:.5pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl84
	{mso-style-parent:style0;
	text-align:center;
	white-space:normal;
	mso-font-charset:134;
	border-top:.5pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl85
	{mso-style-parent:style0;
	text-align:center;
	white-space:normal;
	mso-font-charset:134;
	border-top:.5pt solid windowtext;
	border-right:1.0pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl86
	{mso-style-parent:style0;
	text-align:left;
	white-space:normal;
	mso-font-charset:134;
	border-left:1.0pt solid windowtext;
	border-top:.5pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl87
	{mso-style-parent:style0;
	text-align:left;
	white-space:normal;
	mso-font-charset:134;
	border-top:.5pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl88
	{mso-style-parent:style0;
	text-align:left;
	white-space:normal;
	mso-font-charset:134;
	border-top:.5pt solid windowtext;
	border-right:.5pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl89
	{mso-style-parent:style0;
	text-align:left;
	white-space:normal;
	mso-font-charset:134;
	border-left:1.0pt solid windowtext;
	border-top:.5pt solid windowtext;}
.xl90
	{mso-style-parent:style0;
	text-align:left;
	white-space:normal;
	mso-font-charset:134;
	border-top:.5pt solid windowtext;}
.xl91
	{mso-style-parent:style0;
	text-align:left;
	white-space:normal;
	mso-font-charset:134;
	border-top:.5pt solid windowtext;
	border-right:.5pt solid windowtext;}
.xl92
	{mso-style-parent:style0;
	text-align:center;
	white-space:normal;
	mso-font-charset:134;
	border-top:.5pt solid windowtext;}
.xl93
	{mso-style-parent:style0;
	text-align:center;
	white-space:normal;
	mso-font-charset:134;
	border-top:.5pt solid windowtext;
	border-right:1.0pt solid windowtext;}
.xl94
	{mso-style-parent:style0;
	text-align:center;
	font-weight:700;
	mso-font-charset:134;
	border-left:1.0pt solid windowtext;
	border-top:1.0pt solid windowtext;
	border-right:.5pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl95
	{mso-style-parent:style0;
	text-align:center;
	font-weight:700;
	mso-font-charset:134;
	border-left:.5pt solid windowtext;
	border-top:1.0pt solid windowtext;
	border-right:.5pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl96
	{mso-style-parent:style0;
	text-align:center;
	font-weight:700;
	mso-font-charset:134;
	border-left:.5pt solid windowtext;
	border-top:1.0pt solid windowtext;
	border-right:1.0pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl97
	{mso-style-parent:style0;
	text-align:left;
	mso-font-charset:134;
	border-left:1.0pt solid windowtext;
	border-top:.5pt solid windowtext;
	border-right:.5pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl98
	{mso-style-parent:style0;
	text-align:left;
	mso-font-charset:134;
	border:.5pt solid windowtext;}
.xl99
	{mso-style-parent:style0;
	text-align:left;
	mso-font-charset:134;
	border-left:.5pt solid windowtext;
	border-top:.5pt solid windowtext;
	border-right:1.0pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl100
	{mso-style-parent:style0;
	text-align:left;
	mso-font-charset:134;
	border:.5pt solid windowtext;}
.xl101
	{mso-style-parent:style0;
	text-align:left;
	mso-font-charset:134;
	border-left:.5pt solid windowtext;
	border-top:.5pt solid windowtext;
	border-right:1.0pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl102
	{mso-style-parent:style0;
	text-align:left;
	mso-font-charset:134;
	border-left:1.0pt solid windowtext;
	border-top:.5pt solid windowtext;
	border-right:.5pt solid windowtext;
	border-bottom:1.0pt solid windowtext;}
.xl103
	{mso-style-parent:style0;
	text-align:left;
	mso-font-charset:134;
	border-left:.5pt solid windowtext;
	border-top:.5pt solid windowtext;
	border-right:.5pt solid windowtext;
	border-bottom:1.0pt solid windowtext;}
.xl104
	{mso-style-parent:style0;
	text-align:left;
	mso-font-charset:134;
	border-left:.5pt solid windowtext;
	border-top:.5pt solid windowtext;
	border-right:.5pt solid windowtext;
	border-bottom:1.0pt solid windowtext;}
.xl105
	{mso-style-parent:style0;
	text-align:left;
	mso-font-charset:134;
	border-left:.5pt solid windowtext;
	border-top:.5pt solid windowtext;
	border-right:1.0pt solid windowtext;
	border-bottom:1.0pt solid windowtext;}
.xl106
	{mso-style-parent:style0;
	text-align:center;
	font-weight:700;
	mso-font-charset:134;
	border-left:1.0pt solid windowtext;
	border-right:.5pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl107
	{mso-style-parent:style0;
	text-align:center;
	font-weight:700;
	mso-font-charset:134;
	border-left:.5pt solid windowtext;
	border-right:.5pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl108
	{mso-style-parent:style0;
	text-align:center;
	font-weight:700;
	mso-font-charset:134;
	border-left:.5pt solid windowtext;
	border-right:1.0pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl109
	{mso-style-parent:style0;
	text-align:left;
	mso-font-charset:134;
	border-left:1.0pt solid windowtext;
	border-top:.5pt solid windowtext;
	border-right:.5pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl110
	{mso-style-parent:style0;
	text-align:left;
	mso-font-charset:134;
	border:.5pt solid windowtext;}
.xl111
	{mso-style-parent:style0;
	text-align:left;
	font-size:12.0pt;
	mso-font-charset:134;
	border:.5pt solid windowtext;}
.xl112
	{mso-style-parent:style0;
	text-align:left;
	font-size:12.0pt;
	mso-font-charset:134;
	border-left:.5pt solid windowtext;
	border-top:.5pt solid windowtext;
	border-right:1.0pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl113
	{mso-style-parent:style0;
	text-align:left;
	white-space:normal;
	mso-font-charset:134;
	border-left:1.0pt solid windowtext;
	border-top:.5pt solid windowtext;
	border-right:.5pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl114
	{mso-style-parent:style0;
	text-align:left;
	white-space:normal;
	mso-font-charset:134;
	border:.5pt solid windowtext;}
.xl115
	{mso-style-parent:style0;
	text-align:center;
	mso-font-charset:134;
	border:.5pt solid windowtext;}
.xl116
	{mso-style-parent:style0;
	text-align:center;
	mso-font-charset:134;
	border-left:.5pt solid windowtext;
	border-top:.5pt solid windowtext;
	border-right:1.0pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl117
	{mso-style-parent:style0;
	text-align:left;
	mso-font-charset:134;
	border-left:.5pt solid windowtext;
	border-top:.5pt solid windowtext;
	border-right:1.0pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl118
	{mso-style-parent:style0;
	text-align:left;
	mso-font-charset:134;
	border-left:1.0pt solid windowtext;
	border-top:.5pt solid windowtext;
	border-right:.5pt solid windowtext;}
.xl119
	{mso-style-parent:style0;
	text-align:left;
	mso-font-charset:134;
	border-left:.5pt solid windowtext;
	border-top:.5pt solid windowtext;
	border-right:.5pt solid windowtext;}
.xl120
	{mso-style-parent:style0;
	text-align:center;
	mso-font-charset:134;
	border-left:.5pt solid windowtext;
	border-top:.5pt solid windowtext;
	border-right:.5pt solid windowtext;}
.xl121
	{mso-style-parent:style0;
	text-align:center;
	mso-font-charset:134;
	border-left:.5pt solid windowtext;
	border-top:.5pt solid windowtext;
	border-right:1.0pt solid windowtext;}
.xl122
	{mso-style-parent:style0;
	text-align:center;
	font-weight:700;
	mso-font-charset:134;
	border-left:1.0pt solid windowtext;
	border-top:1.0pt solid windowtext;
	border-right:.5pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl123
	{mso-style-parent:style0;
	text-align:center;
	font-weight:700;
	mso-font-charset:134;
	border-left:.5pt solid windowtext;
	border-top:1.0pt solid windowtext;
	border-right:.5pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl124
	{mso-style-parent:style0;
	text-align:center;
	font-weight:700;
	mso-font-charset:134;
	border-left:.5pt solid windowtext;
	border-top:1.0pt solid windowtext;
	border-right:1.0pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl125
	{mso-style-parent:style0;
	text-align:left;
	white-space:normal;
	mso-font-charset:134;
	border:.5pt solid windowtext;}
.xl126
	{mso-style-parent:style0;
	text-align:left;
	white-space:normal;
	mso-font-charset:134;
	border-left:.5pt solid windowtext;
	border-top:.5pt solid windowtext;
	border-right:1.0pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl127
	{mso-style-parent:style0;
	text-align:left;
	white-space:normal;
	mso-font-charset:134;
	border-left:1.0pt solid windowtext;
	border-top:.5pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl128
	{mso-style-parent:style0;
	text-align:left;
	white-space:normal;
	mso-font-charset:134;
	border-top:.5pt solid windowtext;
	border-right:.5pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl129
	{mso-style-parent:style0;
	text-align:left;
	white-space:normal;
	mso-font-charset:134;
	border-left:.5pt solid windowtext;
	border-top:.5pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl130
	{mso-style-parent:style0;
	text-align:left;
	white-space:normal;
	mso-font-charset:134;
	border-top:.5pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl131
	{mso-style-parent:style0;
	text-align:left;
	white-space:normal;
	mso-font-charset:134;
	border-top:.5pt solid windowtext;
	border-right:1.0pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl132
	{mso-style-parent:style0;
	text-align:center;
	white-space:normal;
	mso-font-charset:134;
	border:.5pt solid windowtext;}
.xl133
	{mso-style-parent:style0;
	text-align:center;
	white-space:normal;
	mso-font-charset:134;
	border-left:.5pt solid windowtext;
	border-top:.5pt solid windowtext;
	border-right:1.0pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl134
	{mso-style-parent:style0;
	text-align:left;
	mso-font-charset:134;
	border-left:1.0pt solid windowtext;
	border-top:.5pt solid windowtext;
	border-right:.5pt solid windowtext;
	border-bottom:1.0pt solid windowtext;}
.xl135
	{mso-style-parent:style0;
	text-align:left;
	mso-font-charset:134;
	border-left:.5pt solid windowtext;
	border-top:.5pt solid windowtext;
	border-right:.5pt solid windowtext;
	border-bottom:1.0pt solid windowtext;}
.xl136
	{mso-style-parent:style0;
	text-align:center;
	mso-font-charset:134;
	border-left:.5pt solid windowtext;
	border-top:.5pt solid windowtext;
	border-right:.5pt solid windowtext;
	border-bottom:1.0pt solid windowtext;}
.xl137
	{mso-style-parent:style0;
	text-align:center;
	mso-font-charset:134;
	border-left:.5pt solid windowtext;
	border-top:.5pt solid windowtext;
	border-right:1.0pt solid windowtext;
	border-bottom:1.0pt solid windowtext;}
.xl138
	{mso-style-parent:style0;
	text-align:center;
	font-size:14.0pt;
	font-weight:700;
	mso-font-charset:134;
	border-left:1.0pt solid windowtext;
	border-top:1.0pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl139
	{mso-style-parent:style0;
	text-align:center;
	font-size:14.0pt;
	font-weight:700;
	mso-font-charset:134;
	border-top:1.0pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl140
	{mso-style-parent:style0;
	text-align:center;
	font-size:14.0pt;
	font-weight:700;
	mso-font-charset:134;
	border-top:1.0pt solid windowtext;
	border-right:1.0pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl141
	{mso-style-parent:style0;
	text-align:left;
	white-space:normal;
	mso-font-charset:134;
	border-left:1.0pt solid windowtext;
	border-top:.5pt solid windowtext;
	border-right:.5pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl142
	{mso-style-parent:style0;
	text-align:left;
	white-space:normal;
	mso-font-charset:134;
	border:.5pt solid windowtext;}
.xl143
	{mso-style-parent:style0;
	text-align:center;
	mso-font-charset:134;
	border:.5pt solid windowtext;}
.xl144
	{mso-style-parent:style0;
	text-align:center;
	mso-font-charset:134;
	border-left:.5pt solid windowtext;
	border-top:.5pt solid windowtext;
	border-right:1.0pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl145
	{mso-style-parent:style0;
	text-align:left;
	white-space:normal;
	mso-font-charset:134;
	border-left:1.0pt solid windowtext;
	border-top:.5pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl146
	{mso-style-parent:style0;
	text-align:left;
	white-space:normal;
	mso-font-charset:134;
	border-top:.5pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl147
	{mso-style-parent:style0;
	text-align:left;
	white-space:normal;
	mso-font-charset:134;
	border-top:.5pt solid windowtext;
	border-right:1.0pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl148
	{mso-style-parent:style0;
	text-align:center;
	mso-font-charset:134;
	border-left:1.0pt solid windowtext;
	border-top:.5pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl149
	{mso-style-parent:style0;
	text-align:center;
	mso-font-charset:134;
	border-top:.5pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl150
	{mso-style-parent:style0;
	text-align:center;
	mso-font-charset:134;
	border-top:.5pt solid windowtext;
	border-right:.5pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl151
	{mso-style-parent:style0;
	text-align:center;
	mso-font-charset:134;
	border-left:.5pt solid windowtext;
	border-top:.5pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl152
	{mso-style-parent:style0;
	text-align:center;
	mso-font-charset:134;
	border-top:.5pt solid windowtext;
	border-right:1.0pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl153
	{mso-style-parent:style0;
	text-align:left;
	white-space:normal;
	mso-font-charset:134;
	border-top:.5pt solid windowtext;
	border-right:.5pt solid windowtext;
	border-bottom:.5pt solid windowtext;}
.xl154
	{mso-style-parent:style0;
	text-align:center;
	mso-font-charset:134;
	border-left:1.0pt solid windowtext;
	border-top:.5pt solid windowtext;
	border-bottom:1.0pt solid windowtext;}
.xl155
	{mso-style-parent:style0;
	text-align:center;
	mso-font-charset:134;
	border-top:.5pt solid windowtext;
	border-bottom:1.0pt solid windowtext;}
.xl156
	{mso-style-parent:style0;
	text-align:center;
	mso-font-charset:134;
	border-top:.5pt solid windowtext;
	border-right:.5pt solid windowtext;
	border-bottom:1.0pt solid windowtext;}
.xl157
	{mso-style-parent:style0;
	text-align:center;
	mso-font-charset:134;
	border-left:.5pt solid windowtext;
	border-top:.5pt solid windowtext;
	border-bottom:1.0pt solid windowtext;}
.xl158
	{mso-style-parent:style0;
	text-align:center;
	mso-font-charset:134;
	border-top:.5pt solid windowtext;
	border-right:1.0pt solid windowtext;
	border-bottom:1.0pt solid windowtext;}
.xl159
	{mso-style-parent:style0;
	font-size:12.0pt;
	mso-font-charset:134;}
.xl160
	{mso-style-parent:style0;
	font-size:12.0pt;
	font-family:微软雅黑, sans-serif;
	mso-generic-font-family:swiss;
	mso-font-charset:134;}
.xl161
	{mso-style-parent:style0;
	font-size:12.0pt;
	mso-font-charset:134;}
.xl162
	{mso-style-parent:style0;
	font-size:12.0pt;
	mso-font-charset:134;}
.xl163
	{mso-style-parent:style0;
	text-align:left;
	font-size:12.0pt;
	mso-font-charset:134;}
.xl164
	{mso-style-parent:style0;
	text-align:center;
	font-size:12.0pt;
	mso-font-charset:134;}
.xl165
	{mso-style-parent:style0;
	font-size:12.0pt;
	mso-font-charset:134;}
.xl166
	{mso-style-parent:style0;
	font-size:12.0pt;
	mso-font-charset:134;}
</style>
